import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Measurement, MeasurementContext, SiUnits, UnitType, UsUnits } from '../../data/engineering-enums';
import { UnitConverterService } from '../../services/unit-converter.service';

@Component({
  selector: 'measurement-text-box',
  templateUrl: './measurement-text-box.component.html',
  styleUrl: './measurement-text-box.component.scss',
  standalone: false
})
export class MeasurementTextBoxComponent {

  constructor(private unitConverter: UnitConverterService) {
  }

  @Input()
  set Value(measurement: Measurement) {
    this.last = measurement;
    this.value = measurement.Value;
    this.unit = measurement.Unit;
    this.setConvertedValue();
  }
  @Output() ValueChange: EventEmitter<Measurement> = new EventEmitter<Measurement>();

  @Input() Context: MeasurementContext;
  @Input()
  set IsUsUnits(value: boolean) {
    this.isUsUnits = value;
    this.setConvertedValue();
  }
  @Input() UsDecimalPlaces: number = 2;
  @Input() SiDecimalPlaces: number = 2;
  @Input() Enabled: boolean = true;

  isUsUnits: boolean = true;
  last: Measurement;
  value: number;
  unit: UnitType;
  convertedValue: string;

  setConvertedValue(): void {
    var toUnit = (this.isUsUnits ? UsUnits.get(this.Context) || UnitType.F : SiUnits.get(this.Context) || UnitType.C);
    if (toUnit !== this.unit) {
      this.convertedValue = this.unitConverter.Convert(this.unit, toUnit, this.value).toFixed(this.isUsUnits ? this.UsDecimalPlaces : this.SiDecimalPlaces);
    }
    else {
      this.convertedValue = this.value.toFixed(this.isUsUnits ? this.UsDecimalPlaces : this.SiDecimalPlaces);
    }
    if (this.convertedValue.indexOf('.') >= 0) {
      this.convertedValue = this.convertedValue.replace(/\.?0+$/, '');
    }
  }

  onChange(event: Event) {
    var fromUnit = (this.isUsUnits ? UsUnits.get(this.Context) || UnitType.F : SiUnits.get(this.Context) || UnitType.C);
    this.value = this.unitConverter.Convert(fromUnit, this.unit, parseFloat(this.convertedValue));
    if (this.last.Value !== this.value) {
      this.last = { Value: this.value, Unit: this.unit };
      this.ValueChange.emit(this.last);
    }
  }

  handleKeyDown(event: KeyboardEvent): void {
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        this.onChange(event);
        break;
    }
  }

  focus(event: FocusEvent): void {
    if (event.target instanceof HTMLInputElement) {
      event.target.select();
    }
  }

}
